import { ProductMergeRule, SkuMergeRule } from "@/services/api/moreFeatures/pickList";

export const productMergeRuleNameMap = {
    [ProductMergeRule.ORIGINAL_ID]: "相同商品ID合并", // 默认
    [ProductMergeRule.NAME]: "相同商品名称合并",
    [ProductMergeRule.EXTERNAL_ID]: "相同商家编码合并",
    [ProductMergeRule.NAME_AND_ORIGINAL_ID]: "相同名称且相同商品ID合并",
    [ProductMergeRule.NAME_AND_EXTERNAL_ID]: "相同名称且相同商家编码合并",
    [ProductMergeRule.ORIGINAL_ID_AND_EXTERNAL_ID]: "相同商品ID且相同商家编码合并",
    [ProductMergeRule.ALL]: "相同商品 ID 且相同名称且相同商家编码合并",
};

export const skuMergeRuleNameMap = {
    [SkuMergeRule.ORIGINAL_ID]: "相同单品ID合并",
    [SkuMergeRule.NAME]: "相同单品名称合并",
    [SkuMergeRule.EXTERNAL_ID]: "相同单品商家编码合并",
    [SkuMergeRule.NAME_WITH_ORIGINAL_ID_OR_EXTERNAL_ID]: "相同名称且(相同单品ID或相同单品商家编码)合并", // 默认
    [SkuMergeRule.NAME_AND_ORIGINAL_ID]: "相同名称且相同单品ID合并",
    [SkuMergeRule.NAME_AND_EXTERNAL_ID]: "相同名称且相同单品商家编码合并",
    [SkuMergeRule.ORIGINAL_ID_AND_EXTERNAL_ID]: "相同单品ID且相同单品商家编码合并",
    [SkuMergeRule.ALL]: "相同名称且相同单品ID且相同单品商家编码合并",
};
